import { isEmpty } from './guards';

/**
 * Remove diacritics from string
 * @param {string} text
 * @returns {string}
 */
export const removeDiacritics = (text: string): string => text.normalize('NFD').replace(/\p{Diacritic}/gu, '');

/**
 * Returns slugified string (no diacritics, no spaces or illegal chars)
 * @param {string} text
 * @returns {string}
 */
export const slugify = (text: unknown): string => {
	if (isEmpty(text) || typeof text !== 'string') return '';
	return removeDiacritics(text)
		.replace(/\s|_|\(|\)|\?|!|\//g, '-')
		.toLowerCase();
};
